import React, { useState, forwardRef, useImperativeHandle } from 'react'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import FormControl from '@mui/material/FormControl'
const CompetitionDuration = forwardRef(({ defaultvar = '72' }, ref) => {
  const [value, setValue] = React.useState(defaultvar || '')
  const [error, setError] = useState('')
  const val = () => {
    return value.trim()
  }

  const validate = () => {
    if (value.trim() === '') {
      setError('Продолжительность турнира обязательно')
      return false
    }
    setError('')
    return true
  }
  useImperativeHandle(ref, () => ({
    validate,
    val,
  }))

  return (
    <FormControl>
      <TextField
        value={value}
        onChange={(e) => setValue(e.target.value)}
        id="duration"
        label="Продолжительность"
        type="number"
        error={!!error}
        fullWidth
        // helperText={error}
      />
      <FormHelperText>Обычно это - 72 или 96 часов</FormHelperText>{' '}
    </FormControl>
  )
})

export default CompetitionDuration
